import React, { useState, useEffect } from 'react';

type Props = {
  delay?: number;
};

const Fallback = ({ delay = 500 }: Props) => {
  const [showLoading, toggleLoading] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => toggleLoading(true), delay);

    return () => {
      clearTimeout(timeout);
    };
  }, [delay]);

  return <>{showLoading && <p>Loading ...</p>}</>;
};

export default Fallback;
